import { BrowseActionDefinition } from "components/actions/actions";
import appModuleRegistry from "components/appModules/appModuleRegistry";
import i18n from "components/i18n/i18n";
import "datatables.net";
import $ from "jquery";
import * as queryString from "lib/queryString/queryString";
import { Table } from "../table";
import { ActionColumnDefinition, ColumnDefinition, TableColumn } from "./ColumnDefinitions";

export class IconColumn implements DataTables.ColumnDefsSettings, TableColumn {
    public width = "1";
    public orderable = false;
    public className = "c-datatable__action-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    public definition: IconColumnDefinition;
    /**
     * Do not render it for each line.
     */
    private cache: string;
    private tooltipCache: any;
    private table: Table;

    constructor(column: number, definition: ColumnDefinition, table: Table) {
        this.targets = column;
        this.definition = definition as IconColumnDefinition;
        this.property = definition.property;
        this.name = this.property;
        this.table = table;
    }

    public render = (data: any, type: string, row: any): any => {
        if (type === "display" && data) {
            if (this.definition.action == null) {
                return this.renderActionlessIcon(this.getTooltip());
            } else if (this.definition.action.actionType === "browse") {
                return this.renderBrowseIcon(this.getTooltip(), row);
            } else {
                if (this.cache == null) {
                    this.renderServerIcon(this.getTooltip());
                }
                return this.cache;
            }
        }
        return null;
    }

    private getTooltip() {
        if (this.tooltipCache == null) {
            this.tooltipCache = "";
            if (this.definition.tooltipKey != null) {
                this.tooltipCache = i18n.instance.t(this.definition.tooltipKey);
            }
        }
        return this.tooltipCache;
    }

    private renderBrowseIcon(tooltip: string, rowData: any) {
        const actionDefinition = this.definition.action as BrowseActionDefinition;
        let url = appModuleRegistry.prefixUrl(actionDefinition.url);

        const data = {};
        $.each((this.definition.action as BrowseActionDefinition).fieldParameterMappings, (key, val) => {
            data[val.as] = this.table.getValueForFieldInRow(val.field, rowData);
        });
        const params = queryString.stringify(data);
        if (params != null && params.length > 0) {
            url = url + "?" + params;
        }

        if (this.definition.iconFont != null) {
            return '<a href="' + url + '" role="button" class="icon" title="' + (tooltip ?? "") + '">'
                + '<i class="fa ' + this.definition.iconFont + '" aria-hidden="true"></i></a>';
        } else {
            return '<a href="' + url + '" role="button" class="icon">A</a>';
        }
    }

    private renderServerIcon(tooltip: string) {
        if (this.definition.iconFont != null) {
            this.cache = '<a href="javascript:void(0)" role="button" class="icon" title="' + (tooltip ?? "") + '">'
                + '<i class="fa ' + this.definition.iconFont + '" aria-hidden="true"></i></a>';
        } else {
            this.cache = '<a href="javascript:void(0)" role="button" class="icon">A</a>';
        }
    }

    private renderActionlessIcon(tooltip: any): any {
        return '<a class="icon" title="' + (tooltip ?? "") + '"><i class="fa ' + this.definition.iconFont + '" aria-hidden="true"></i></a>';
    }
}

export interface IconColumnDefinition extends ActionColumnDefinition {
    iconFont?: string;
}
